module.exports = __webpack_public_path__ + "img/ico-final-inspection.f5cd0c15.svg";